import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["bar", "pin"];

  connect() {
    this.onScroll = this.onScroll.bind(this);
    this.navOffset = 56;
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onScroll);
  }

  onScroll() {
    const booking = this.bookingEl();
    if (!booking) return;

    const compact = this.shouldCompact(booking);
    booking.classList.toggle("is-compact", compact);

    if (!this.hasBarTarget) return;

    const rect = booking.getBoundingClientRect();
    const visible =
      rect.top < window.innerHeight - 24 &&
      rect.bottom > this.navOffset + 8;
    this.barTarget.classList.toggle("translate-y-full", visible);
    this.barTarget.classList.toggle("translate-y-0", !visible);
  }

  bookingEl() {
    if (this.hasPinTarget) {
      return this.pinTarget.querySelector(".deal-buybox") || this.pinTarget;
    }
    return document.getElementById("booking-card");
  }

  shouldCompact(booking) {
    if (window.matchMedia("(min-width: 1024px)").matches) return false;
    if (!this.hasPinTarget) return false;

    const pinRect = this.pinTarget.getBoundingClientRect();
    const stuck = pinRect.top <= this.navOffset + 2;
    // Still in the sticky track (not scrolled away past related offers)
    const inTrack = pinRect.bottom > this.navOffset + 40;
    return stuck && inTrack;
  }
}
